import React, { useState, useEffect } from "react"
import walkinImg from "../../../assets/images/Mega-Walk-In-Drive-Popup-Image.png"
import walkinImgMobile from "../../../assets/images/Mega-Walk-In-Drive-Popup-Image - Mobile.png" // Add your mobile image path here

const MegaWalkInDriveModal = () => {
  const [isOpen, setIsOpen] = useState(true)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    // Function to check if the screen is mobile
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768) // Common breakpoint for mobile devices
    }

    // Check initially
    checkIfMobile()

    // Add event listener for window resize
    window.addEventListener("resize", checkIfMobile)

    // Clean up event listener
    return () => {
      window.removeEventListener("resize", checkIfMobile)
    }
  }, [])

  const closeModal = () => {
    setIsOpen(false)
  }

  return (
    <>
      {isOpen && (
        <div
          className="fixed z-30 inset-0 overflow-y-auto"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
              aria-hidden="true"
            ></div>

            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>

            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl max-w-full w-full">
              {/* Header with gradient background */}
              <div className="relative bg-blue-600 p-0 text-white">
                {/* <button
                  onClick={closeModal}
                  className="absolute top-2 right-2 md:top-4 md:right-4 text-white hover:text-gray-200 z-10"
                  aria-label="Close modal"
                >
                  X
                </button> */}

                <div
                  className="absolute right-0 opacity-100 cursor-pointer z-50 top-2 right-2 text-white p-2"
                  aria-hidden="true"
                  onClick={closeModal}
                  style={{
                    fontSize: "55px",
                    lineHeight: "30px",
                    transform: "rotate(45deg)",
                  }}
                >
                  <span>+</span>
                </div>

                {/* Full-width and full-height image with responsive switching */}
                <div className="w-full">
                  <img
                    src={
                      isMobile
                        ? "https://webmobtechcdn.nyc3.cdn.digitaloceanspaces.com/wmt_v4/2025/04/Mega-Walk-In-Drive-Popup-Image-Mobile.png"
                        : "https://webmobtechcdn.nyc3.cdn.digitaloceanspaces.com/wmt_v4/2025/04/Mega-Walk-In-Drive-Popup-Image.png"
                    }
                    alt="MEGA WALK-IN DRIVE"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* Details section */}
              <div className="p-4 md:p-6">
                <h3 className="text-base md:text-lg font-bold text-gray-900 mb-3 md:mb-4">
                  Details
                </h3>

                <div className="flex flex-col md:flex-row md:items-center mb-4">
                  <div className="flex items-center mb-2 md:mb-0 md:mr-6">
                    {/* <Calendar className="text-blue-600 mr-2" size={18} /> */}
                    <i className="icon-alternate-saturdays-week-off text-blue-500 text-lg mr-2"></i>
                    <span className="text-sm md:text-base text-black">
                      26th April 2025 | SAT
                    </span>
                  </div>

                  <div className="flex items-center">
                    <i className="icon-ai-ces-time-material text-blue-500 text-lg mr-2"></i>
                    {/* <Clock className="text-blue-600 mr-2" size={18} /> */}
                    <span className="text-sm md:text-base text-black">
                      10:00 AM — 5:00 PM
                    </span>
                  </div>
                </div>

                <h3 className="text-base md:text-lg font-bold text-gray-900 mt-4 md:mt-6 mb-3 md:mb-4">
                  Open Positions
                </h3>

                <div className="flex flex-wrap gap-2 mb-4">
                  <span
                    className="text-blue-500 px-2 py-1 md:px-3 md:py-2 rounded-md text-xs md:text-base font-semibold"
                    style={{ backgroundColor: "#ebefff" }}
                  >
                    Business Development Personnel
                  </span>
                  <span
                    className="text-blue-500 px-2 py-1 md:px-3 md:py-2 rounded-md text-xs md:text-base font-semibold"
                    style={{ backgroundColor: "#ebefff" }}
                  >
                    Laravel
                  </span>
                  <span
                    className="text-blue-500 px-2 py-1 md:px-3 md:py-2 rounded-md text-xs md:text-base font-semibold"
                    style={{ backgroundColor: "#ebefff" }}
                  >
                    UI/UX
                  </span>
                  <span
                    className="text-blue-500 px-2 py-1 md:px-3 md:py-2 rounded-md text-xs md:text-base font-semibold"
                    style={{ backgroundColor: "#ebefff" }}
                  >
                    MERN
                  </span>
                  <span
                    className="text-blue-500 px-2 py-1 md:px-3 md:py-2 rounded-md text-xs md:text-base font-semibold"
                    style={{ backgroundColor: "#ebefff" }}
                  >
                    Business Analyst
                  </span>
                  <span
                    className="text-blue-500 px-2 py-1 md:px-3 md:py-2 rounded-md text-xs md:text-base font-semibold"
                    style={{ backgroundColor: "#ebefff" }}
                  >
                    Founder's Office
                  </span>
                  <span
                    className="text-blue-500 px-2 py-1 md:px-3 md:py-2 rounded-md text-xs md:text-base font-semibold"
                    style={{ backgroundColor: "#ebefff" }}
                  >
                    Digital Marketing
                  </span>
                  <span
                    className="text-blue-500 px-2 py-1 md:px-3 md:py-2 rounded-md text-xs md:text-base font-semibold"
                    style={{ backgroundColor: "#ebefff" }}
                  >
                    Quality Analyst
                  </span>
                  <span
                    className="text-blue-500 px-2 py-1 md:px-3 md:py-2 rounded-md text-xs md:text-base font-semibold"
                    style={{ backgroundColor: "#ebefff" }}
                  >
                    Flutter
                  </span>
                  <span
                    className="text-blue-500 px-2 py-1 md:px-3 md:py-2 rounded-md text-xs md:text-base font-semibold"
                    style={{ backgroundColor: "#ebefff" }}
                  >
                    HR(Talent Acquisition)
                  </span>
                  <span
                    className="text-blue-500 px-2 py-1 md:px-3 md:py-2 rounded-md text-xs md:text-base font-semibold"
                    style={{ backgroundColor: "#ebefff" }}
                  >
                    AI/ML
                  </span>
                </div>

                <p className="text-xs md:text-sm text-black mb-4 md:mb-6">
                  <span className="text-red-500">*</span>Please{" "}
                  <strong>carry your own laptop</strong> when attending the
                  walk-in drive.
                </p>
                <p className="text-xs md:text-sm text-black mb-4 md:mb-6">
                  <strong className="text-red-500">Note: </strong>AI Savvy
                  Candidates: <strong>Top Priority!</strong>
                </p>
                <div className="flex justify-end">
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLScJJNjotr3XgoezNSdzfZtwpolGLDCo-BCSqkX9AjrsQdzKqw/viewform"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-blue-500 text-white py-2 px-4 md:py-2 md:px-6 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 w-32 md:w-40 h-10 md:h-12 text-sm md:text-base text-center flex items-center justify-center"
                  >
                    Register Now!
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default MegaWalkInDriveModal
